<template>
  <div class="c-filter">
    <div class="c-btn"></div>
    <div class="c-form">
      <ElForm label-width="50" inline class="elementui-common-form-styles" v-highlight>
        <ElFormItem label="账号">
          <ElSelect v-model="adAccountId" transfer clearable filterable>
            <el-option v-for="option in accountData" :value="option.id" :label="option.name" :key="option.id"></el-option>
          </ElSelect>
        </ElFormItem>
        <ElFormItem label="游戏">
          <ElSelect v-model="gameId" transfer clearable filterable>
            <el-option v-for="option in GAMES" :value="option.id" :label="option.name" :key="option.id"></el-option>
          </ElSelect>
        </ElFormItem>
        <ElFormItem label="创建人">
          <ElSelect v-model="agentId" transfer clearable filterable>
            <el-option v-for="option in PTOM_USERS" :value="option.id" :label="option.name" :key="option.id"></el-option>
          </ElSelect>
        </ElFormItem>
        <ElFormItem label="更新人">
          <ElSelect v-model="updateId" transfer clearable filterable>
            <el-option v-for="option in PTOM_USERS" :value="option.id" :label="option.name" :key="option.id"></el-option>
          </ElSelect>
        </ElFormItem>

        <ElFormItem class="bg-transparent">
          <ElButton type="primary" @click="sendEvent">查询</ElButton>
        </ElFormItem>
        <ElFormItem class="g-pull-right bg-transparent">
          <ElButton type="primary" @click="$emit('add-set')">创建小游戏配置</ElButton>
        </ElFormItem>
      </ElForm>
    </div>
  </div>
</template>
<script>
import { initPageData, GAMES, PTOM_USERS } from '@/data/global-opts'

// 当前页面需要的下拉数据项
const PAGE_REQUIRED_OPTS = initPageData([GAMES, PTOM_USERS])
export default {
  name: 'baiduFilter',
  props: {
    accountData: {
      type: Array
    }
  },
  computed: {
    ...PAGE_REQUIRED_OPTS
  },
  methods: {
    sendEvent() {
      const params = {
        gameId: this.gameId === '' ? undefined : this.gameId,
        opId: this.agentId === '' ? undefined : this.agentId,
        upOpId: this.updateId === '' ? undefined : this.updateId,
        adAccountId: this.adAccountId === '' ? undefined : this.adAccountId
      }
      this.$emit('on-change', params)
    }
  },
  data() {
    return {
      keyword: '',
      gameId: '',
      agentId: '',
      updateId: '',
      adAccountId: ''
    }
  },
  created() {
    this.sendEvent()
  }
}
</script>
